import { useTranslation } from "react-i18next";
import textos from "./textos/BarAlbeniz.jsx";

// Pàgina "bar-albeniz" de l'Hotel Camprodon. Els textos propis de cada idioma
// són a textos/BarAlbeniz.jsx; els genèrics, amb t() (Traducciones/lang).
// El comportament (sliders, galeria, formularis...) és a ContenidoHtml.
const BarAlbeniz = ({ lang }) => {

    const { t } = useTranslation();
    const tx = textos[lang] ?? textos.es;

    return (
        <>
            <section className="c-hero c-hero--large">
                <div className="c-hero--container" style={{maxHeight: "100vh"}}>
                    <div>
                        <div className="position-relative">
                            <picture>
                                <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__1920x1036__salon-bar-albeniz-barra-hotel-camprodon-1681390901.jpg" alt={tx.heroImageAlt} className="image-cover image-full c-hero__image" width="100%" height="100%" />
                            </picture>
                            <div className="c-hero__content position-relative">
                                <span className="c-hero__small-title text-uppercase">{tx.heroSmallTitle}</span>
                                <h1 className="c-hero__title">{tx.heroTitle}</h1>
                                <span className="line max-line-height">
                                    <svg aria-hidden="true" focusable="false" className="c-icon ico-mouse">
                                        <use href="/images/web/hotelcamprodon/icons-sprite.svg#sprite-icon-ico-mouse-scrolldown"></use>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div id="c-sticky-widget-notifier"></div>
            <section className="c-sticky-widgets d-inline-flex position-relative">
                <div className="c-sticky-widgets--button c-sticky-widgets--restaurant d-flex-center"><a href={tx.stickyWidgetsButtonHref} target="_blank" className="text-uppercase text-center d-flex-center" rel="noopener noreferrer">{t("Reserva restaurante")}</a></div>
            </section>
            <section className="c-presentation o-container text-center ">
                <div className="c-presentation__small-title text-uppercase">{tx.presentationSmallTitle}</div>
                <h2 className="c-presentation__title">{tx.presentationTitle}</h2>
                <div className="c-presentation__content">
                    <p>{tx.presentationContent}</p>
                </div>
            </section>
            <section className="o-container">
                <article className="c-card c-card--featured ">
                    <div className="c-card__header">
                        <div className="c-slider-controls-above c-slider-controls-above--bottom-right">
                            <div>
                                <picture>
                                    <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__544x544__chimenea-sillones-bar-albeniz-hotel-camprodon-1681390901.jpg" alt={tx.sliderControlsAboveAlt} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div className="c-card__body">
                        <div className="c-card__content">
                            <h2 className="c-card__title">{tx.cardTitle}</h2>
                            <p>{tx.cardContent}</p>
                        </div>
                        <div className="c-card__footer"></div>
                    </div>
                </article>
                <article className="c-card c-card--featured c-card--reverse">
                    <div className="c-card__header">
                        <div className="c-slider-controls-above c-slider-controls-above--bottom-right">
                            <div>
                                <picture>
                                    <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__544x544__salon-bar-albeniz-hotel-camprodon-1681390902.jpg" alt={tx.sliderControlsAboveAlt2} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div className="c-card__body">
                        <div className="c-card__content">
                            <h2 className="c-card__title">{tx.cardTitle2}</h2>
                            <p>{tx.cardContent2}</p>
                        </div>
                        <div className="c-card__footer"></div>
                    </div>
                </article>
                <article className="c-card c-card--featured ">
                    <div className="c-card__header">
                        <div className="c-slider-controls-above c-slider-controls-above--bottom-right">
                            <div>
                                <picture>
                                    <img src="/images/web/hotelcamprodon/p/estiu-jazz__544x544__mesas-escenario-hotel-camprodon-1677074128.jpg" alt={tx.sliderControlsAboveAlt3} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                                </picture>
                            </div>
                        </div>
                    </div>
                    <div className="c-card__body">
                        <div className="c-card__content">
                            <h2 className="c-card__title">{tx.cardTitle3}</h2>
                            <p>{tx.cardContent3}</p>
                            <p>{tx.cardContent4}</p>
                        </div>
                        <div className="c-card__footer"></div>
                    </div>
                </article>
            </section>
            <section className="c-presentation bottom-presentation o-container text-center">
                <div className="c-presentation__small-title text-uppercase"></div>
                <h2 className="c-presentation__title"></h2>
                <div className="c-presentation__content"></div>
            </section>
            <section className="gallery-section o-container">
                <div className="c-section-head   c-section-head--not-default ">
                    <span className="c-section-head__subtitle text-uppercase color-primary">{tx.sectionHeadSubtitle}</span>
                    <h2 className="c-section-head__title">{tx.sectionHeadTitle}</h2>
                    <div className="c-section-head__texts">
                        <p>{tx.sectionHeadTexts}</p>
                    </div>
                </div>
                <div className="c-gallery">
                    <div className="c-gallery-item position-relative" href="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__1920x1280__barra-bar-albeniz-hotel-camprodon-1681390900.webp">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__345x345__barra-bar-albeniz-hotel-camprodon-1681390900.jpg" alt={tx.galleryItemAlt} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                    <div className="c-gallery-item position-relative" href="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__1920x1280__salon-bar-albeniz-barra-hotel-camprodon-1681390901.webp">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__345x345__salon-bar-albeniz-barra-hotel-camprodon-1681390901.jpg" alt={tx.galleryItemAlt2} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                    <div className="c-gallery-item position-relative" href="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__1920x1280__cafe-mesa-salon-chimenea-bar-albeniz-hotel-camprodon-1681390901.webp">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__345x345__cafe-mesa-salon-chimenea-bar-albeniz-hotel-camprodon-1681390901.jpg" alt={tx.galleryItemAlt3} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                    <div className="c-gallery-item position-relative" href="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__1920x1280__salon-bar-albeniz-hotel-camprodon-1681390902.webp">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__345x345__salon-bar-albeniz-hotel-camprodon-1681390902.jpg" alt={tx.galleryItemAlt4} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                    <div className="c-gallery-item position-relative" href="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__1920x1280__chimenea-sillones-bar-albeniz-hotel-camprodon-1681390901.webp">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__345x345__chimenea-sillones-bar-albeniz-hotel-camprodon-1681390901.jpg" alt={tx.galleryItemAlt5} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                    <div className="c-gallery-item position-relative" href="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__724x1080__salon-hotel-camprodon-1681390902.webp">
                        <picture>
                            <img src="/images/web/hotelcamprodon/p/0-fotos-noves__bar-albeniz__345x345__salon-hotel-camprodon-1681390902.jpg" alt={tx.galleryItemAlt6} className="image-cover" width="100%" height="100%" loading="lazy" decoding="async" />
                        </picture>
                    </div>
                </div>
                <div className="c-gallery-button text-center">
                    <button className="c-button c-button--secondary text-uppercase">{t("Ver más imágenes")}</button>
                </div>
            </section>
        </>
    );
};

export default BarAlbeniz;
